module.exports = __webpack_public_path__ + "static/media/roomType.8606e458.png";